import { LinkButton } from "~/common/components/Link";
import { useTranslation } from "react-i18next";
import { type MouseEventHandler } from "react";
import SwapVertIcon from "@mui/icons-material/SwapVert";

interface Props {
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}
export const ResetSortBtn = ({ className, onClick }: Props) => {
  const { t } = useTranslation();
  return (
    <LinkButton className={className} onClick={onClick} iconBefore={<SwapVertIcon  />}>
      {t("page.selectionAssistant.resetSort")}
    </LinkButton>
  );
};
